var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1663638542109,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 18518,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M570.3 138.5l83 151.2c9.8 17.8 27 30.3 46.9 34.1L869.7 356c52.7 10 73.6 74.3 36.8 113.4L788.3 595c-13.9 14.8-20.5 35-17.9 55.2l21.8 171.1c6.8 53.2-47.9 93-96.5 70.1l-156-73.6c-18.4-8.7-39.7-8.7-58 0l-156 73.6c-48.5 22.9-103.2-16.8-96.5-70.1L251 650.2c2.6-20.1-4-40.4-17.9-55.2L114.8 469.4C78.1 430.3 99 366 151.7 356l169.5-32.2c20-3.8 37.2-16.3 46.9-34.1l83-151.2c25.8-47.1 93.4-47.1 119.2 0z",
    "p-id": 18519,
    fill: "#f5bb4a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeed);
export default __webpack_public_path__ + "static/media/likeed.6085c8df.svg";
export { ForwardRef as ReactComponent };